module.exports = __webpack_public_path__ + "img/bg.6a816e3a.png";